import axios from 'axios';
import store from '../store';
import router from '../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: `${API_URL}/api/labelbase`,
});

api.interceptors.request.use((config) => {
  const token = store.state.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('logout');
      router.push('/login');
    }
    return Promise.reject(error);
  },
);

export default api;
